<div class="container">
  <div class="actions">
    <button (click)="addVehicle()" class="btn-action">
      <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
      Add Vehicle</button>
      <button (click)="bulkUploadOpen()" class="btn-action">
      <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
      Bulk Upload</button>
      <button
              type="button"
              class="btn-icon-action"
              (click)="downloadTemplate()"
              title="Download Vehicle Import Template">
          <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
      </button>
  </div>

    <app-bulk-import-result
            *ngIf="bulkUpload.result"
            [totalImported]="bulkUpload.result.totalImported"
            [totalFailed]="bulkUpload.result.totalFailed"
            [errors]="bulkUpload.result.errors"
            [failedRowsCsvBase64]="bulkUpload.result.failedRowsCsvBase64"
            [failedRowsFilename]="bulkUpload.result.failedRowsFilename">
    </app-bulk-import-result>
  
  <div class="container-table">
    <header class="top-header">
     <h3>Vehicle Records</h3>
        <p>Vehicle Details As On {{todayDate | reportingDate:'date' }}</p>
    </header>
    <!-- <div class="card-top card-head">
      <h4>Vehicle Records</h4>
      <p>Vehicle Details As On {{todayDate | reportingDate:'date' }}</p>
    </div> -->
    <!-- <header class="top-header">
      <h3>Profile Info</h3>
    </header> -->
    <div>
        <app-shared-table-toolbar>
            <div toolbarSearch class="search-bar wide-search-bar">
              <app-generic-search
              [apiUrl]="'vehicles/search_suggestion'"
              [resultsApiUrl]="'vehicles/'"
              [method]="'GET'"
              [searchParamName]="'q'"
              [pageSize]="10"
              [minChars]="2"
              (resultsFetched)="onResults($event)">
            </app-generic-search>
        </div>
            <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
          <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
          EXPORT EXCEL
        </button>
        </app-shared-table-toolbar>
        <app-shared-bulk-selection-banner
                *ngIf="canBulkDelete"
                [visible]="hasBulkSelection"
                [selectedCount]="bulkSelectedCount"
                [matchingCount]="totalRecords"
                [mode]="bulkSelection.mode"
                [showSelectAllMatching]="true"
                itemLabel="vehicles"
                (selectAllMatching)="onSelectAllMatching()"
                (clearSelection)="onClearBulkSelection()">
            <button bulkSelectionActions
                    type="button"
                    class="btn-action"
                    (click)="openBulkDeletePreview()"
                    [disabled]="!hasBulkSelection || bulkDeleting"
                    title="Bulk Delete selected vehicles">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                Bulk Delete
            </button>
        </app-shared-bulk-selection-banner>
      <div class="responsive-table-wrapper">
        <table>
          <thead>
              <tr>
                  <th *ngIf="canBulkDelete">
                      <input type="checkbox"
                             class="vehicle-select-checkbox"
                             [checked]="allVisibleSelected"
                             (change)="toggleSelectAll($any($event.target).checked)">
                  </th>
              <th>S.No</th>
                  <th class="sortable-header" (click)="sortData('employee_id')">
                      EmpId
                      <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'employee_id' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'employee_id' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                  </th>
                  <th class="sortable-header" (click)="sortData('vehicle_number')">
                      Vehicle No
                      <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                  </th>
                  <th class="sortable-header" (click)="sortData('person_name')">
                      Person Name
                      <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'person_name' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'person_name' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                  </th>
                  <th class="sortable-header" (click)="sortData('created_by__username')">
                      Added By
                      <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_by__username' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_by__username' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                  </th>
                  <th class="sortable-header" (click)="sortData('created_at')">
                      Created On
                      <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                  </th>
              <th>Action Items</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let record of vehicleDatabase let i = index ">
                  <td *ngIf="canBulkDelete">
                      <input type="checkbox"
                             class="vehicle-select-checkbox"
                             [checked]="isVehicleSelected(record.id)"
                             (change)="toggleVehicleSelection(record.id, $any($event.target).checked)">
                  </td>
                <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
                <td>{{ record.employee_id }}</td>
                  <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                <td>{{ record.person_name }}</td>
                <td>{{ record.created_by }}</td>
                  <td>{{ record.created_at | reportingDate }}</td>
                <td>
                  <button class="action-button bt-edit" (click)="updateVehicle(record.id)" title="Edit">
                    <span>
                      <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                  <button class="action-button bt-blacklist" (click)="openBlacklistConfirmationDialog(record)" title="Add To Blacklist">
                    <span>
                      <fa-icon [icon]="['fas', 'ban']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                    <button class="action-button bt-hotlist" (click)="openHotlistConfirmationDialog(record)"
                            title="Add to Hotlisted Vehicles">
                    <span>
                      <fa-icon [icon]="['fas', 'fire']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                  <button class="action-button bt-delete" (click)="openConfirmationDialog(record.id)" title="Delete">
                    <span>
                      <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
      
        <div class="footer">
          <div class="total-records">Total Records: {{ totalRecords }}</div>
            <app-vte-pagination
                    [currentPage]="currentPage"
                    [pageSize]="recordsPerPage"
                    [totalRecords]="totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
            </app-vte-pagination>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Modal Confirmation dialog -->
<div *ngIf="showConfirmationDialog" class="confirmation-modal">
  <div class="modal-content">
    <div class="modal-header">
      <i class="bi bi-exclamation-triangle warning-icon"></i>
      <h3>{{ confirmationTitle }}</h3>
    </div>
    <div class="modal-body">
      <p>{{ confirmationMessage }}</p>
    </div>
    <div class="modal-footer">
      <button (click)="confirmAction()" class="confirm-btn modal-red">Yes, Proceed</button>
      <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="showBulkDeleteDialog && bulkDeletePreview" class="confirmation-modal">
    <div class="modal-content">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon"></i>
            <h3>Confirm Bulk Delete</h3>
        </div>
        <div class="modal-body">
            <p><strong>Will be deleted</strong></p>
            <ul>
                <li>Vehicles: {{ bulkDeletePreview.will_delete?.vehicles || 0 }}</li>
                <li>Related Monitoring Rules: {{ bulkDeletePreview.will_delete?.monitoring_rules || 0 }}</li>
            </ul>
            <p><strong>Related records retained (not deleted)</strong></p>
            <ul>
                <li>Blacklist entries: {{ bulkDeletePreview.related_retained?.blacklisted || 0 }}</li>
                <li>Hotlist entries: {{ bulkDeletePreview.related_retained?.hotlisted || 0 }}</li>
                <li>Vehicle Logs: {{ bulkDeletePreview.related_retained?.vehicle_logs || 0 }}</li>
                <li>Alert Logs: {{ bulkDeletePreview.related_retained?.alert_logs || 0 }}</li>
            </ul>
            <p>{{ bulkDeletePreview.note }}</p>
        </div>
        <div class="modal-footer">
            <button (click)="confirmBulkDelete()" class="confirm-btn modal-red" [disabled]="bulkDeleting">
                {{ bulkDeleting ? 'Deleting...' : 'Yes, Delete' }}
            </button>
            <button (click)="closeBulkDeleteDialog()" class="cancel-btn cancel-btn-green" [disabled]="bulkDeleting">
                Cancel
            </button>
        </div>
    </div>
</div>

<app-bulk-upload-shell
        mode="modal"
        [open]="bulkUpload.dialogOpen"
        [title]="bulkUploadShell.title!"
        [intro]="bulkUploadShell.intro!"
        [uploading]="bulkUpload.uploading"
        [selectedFile]="bulkUpload.selectedFile"
        [showDownloadTemplate]="!!bulkUploadShell.showDownloadTemplate"
        [showGuidelines]="!!bulkUploadShell.showGuidelines"
        (downloadTemplate)="downloadTemplate()"
        (guidelinesClick)="openGuidelines()"
        (fileSelected)="onBulkFileSelected($event)"
        (submitUpload)="submitBulkUpload($event)"
        (cancel)="closeBulkUploadDialog()">
</app-bulk-upload-shell>

<div *ngIf="showGuidelinesModal" class="confirmation-modal">
    <div class="modal-content">
        <div class="close">
            <span (click)="closeGuidelinesModal()">
                <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
            </span>
        </div>
        <div class="modal-header">
            <h3>Sample Guidelines</h3>
        </div>
        <div class="modal-body" *ngIf="sampleGuidelines">
            <div class="guideline" *ngFor="let guideline of sampleGuidelines | keyvalue: originalOrder">
                <span class="icon">➜</span>
                <div>
                    <strong>{{ guideline.key }}</strong>
                    <p>{{ guideline.value }}</p>
                </div>
            </div>
        </div>
    </div>
</div>